var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGigsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 239.73 259.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#282333;opacity:.17;}.cls-3{fill:url(#linear-gradient-8);}.cls-4{fill:url(#linear-gradient-9);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{opacity:.35;}.cls-12{fill:url(#linear-gradient-13);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-10);}.cls-15{fill:url(#linear-gradient-11);}.cls-16{fill:#fff;opacity:.41;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2992.88,
    y1: 184.37,
    x2: -2856.62,
    y2: 232.49,
    gradientTransform: "translate(-2778.67) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1823.43,
    y1: 656.5,
    x2: -1803.05,
    y2: 567.39,
    gradientTransform: "translate(-1722.67 -432.28) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a80f82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f006a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2906.36,
    y1: 6.64,
    x2: -2917.59,
    y2: 74.01,
    gradientTransform: "translate(-2778.67) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0283cf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2876.19,
    y1: 109.28,
    x2: -2919.35,
    y2: 199.99,
    gradientTransform: "translate(-2778.67) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0296cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02dbcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -2975.59,
    y1: 233.13,
    x2: -2842.25,
    y2: 104.21,
    gradientTransform: "translate(-2778.67) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02dbcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0270cf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -3015.64,
    y1: 174.56,
    x2: -2787.95,
    y2: 164.68,
    gradientTransform: "translate(-2778.67) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0296cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c15ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2902.01,
    y1: 165.38,
    x2: -2938.76,
    y2: 222.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2875.95,
    y1: 5.06,
    x2: -2892.2,
    y2: 44.44,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -3018.4,
    y1: 211.63,
    x2: -2960.8,
    y2: 211.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -2904.15,
    y1: 173.56,
    x2: -2918.53,
    y2: 217.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -2919.72,
    y1: 164.77,
    x2: -2921.63,
    y2: 170.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -2876.78,
    y1: 236.04,
    x2: -2895.16,
    y2: 153.58,
    gradientTransform: "translate(-2778.67) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -2942.52,
    y1: 214.44,
    x2: -2943.47,
    y2: 90.77,
    gradientTransform: "translate(-2778.67) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.44,196.01c4.62,23.5,26.4,36.69,47.35,36.22,14.38-.33,25.43-2.62,33.06-8.12-31.14-23.66-24.98-51.73-24.98-51.73,7.12,6.59,18.37,25.79,55.71,31.14,1.06,.15,2.12,.26,3.19,.36,.32,.03,.65,.05,.98,.07,.77,.06,1.54,.1,2.32,.13,.35,.01,.69,.02,1.04,.03,.85,.02,1.7,.02,2.56,0,.23,0,.46,0,.7,0,1.12-.03,2.23-.07,3.35-.15,.09,0,.19-.02,.28-.02,1.02-.07,2.04-.16,3.06-.26,.24-.02,.48-.05,.72-.08,.93-.1,1.85-.22,2.77-.35,.19-.03,.38-.05,.56-.08,2.28-.33,4.54-.74,6.76-1.2,19.57-4.09,35.86-12.57,35.86-12.57,.37,16.06-25.72,42.35-55.51,44.35-.69,.05-1.39,.09-2.08,.11-1.06,.97-2.13,1.91-3.21,2.82-.24,.2-.48,.41-.72,.61-1.02,.85-2.06,1.68-3.1,2.48-.27,.21-.54,.41-.82,.61-.86,.65-1.73,1.28-2.61,1.9-.28,.19-.55,.4-.83,.59-.99,.68-1.98,1.32-2.98,1.96-.41,.26-.82,.51-1.23,.76-.98,.6-1.97,1.18-2.96,1.74-8.83,3.86-18.57,6.02-28.83,6.02-34.75,0-63.74-24.6-70.53-57.34h.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M166.64,245.59c.41-.25,.82-.51,1.23-.76,.05-.03,.09-.06,.14-.09-.66,.42-1.32,.82-1.99,1.22,.2-.12,.41-.24,.62-.36Zm-102.32-49.58h.12c-.47-2.4-.77-4.91-.86-7.53-.95-26.5,13.93-42.15,37.03-42.68,11.19-.26,21.75,3.59,29.11,10.9,1.99,1.98,3.94,3.95,5.94,5.89-.11-.16-41.13-56.3-87.06-32.73C.46,154.57,19.96,233.22,73.49,253.22c12.47,4.47,25.94,6.8,39.98,6.48,19.32-.44,35.55-4.24,50.05-12.31-8.79,3.82-18.48,5.95-28.67,5.95-34.75,0-63.74-24.6-70.53-57.34Zm99.36,51.32c.23-.13,.45-.27,.67-.39-.27,.16-.55,.3-.83,.46,.05-.02,.1-.04,.15-.06Zm9.4-6.06c.41-.3,.81-.58,1.22-.89,.27-.2,.54-.4,.81-.61-.67,.52-1.35,1-2.03,1.5Zm-2.22,1.6c.23-.16,.45-.32,.68-.48-.64,.45-1.29,.87-1.93,1.3,.42-.28,.84-.54,1.26-.82Zm.83-.59c.47-.33,.93-.67,1.39-1.01-.51,.37-1.02,.76-1.54,1.12,.05-.04,.1-.07,.15-.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M95.83,0c69.53,4.45,82.9,60.96,82.9,60.96,0,0-40.84-31.2-87.51-21.29C106.29,23.09,95.83,0,95.83,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.21,39.67h0c46.66-9.91,87.51,21.29,87.51,21.29h-.03c25.58,19.76,42.36,50.47,43.16,85.3,.31,13.42-1.78,26.33-5.88,38.34h0s-8.41-105.45-88.79-123.64C46.8,42.77,0,102.48,.03,151.32-1.23,95.94,38.34,49.16,91.21,39.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M127.18,60.96c80.38,18.19,88.79,123.64,88.79,123.64h0c3.13-9.19,5.09-18.92,5.7-28.99-.61,10.08-2.57,19.8-5.7,28.99h0c-75.78-29.3-48.12-60.92-75.27-82.89C105.06,72.86,9.04,60.96,1.74,168.44c-1-5.57-1.58-11.29-1.71-17.12H.03C0,102.48,46.8,42.77,127.18,60.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M140.71,101.71c27.14,21.97-.51,53.59,75.27,82.89-3,.31-6.02,.58-9.09,.61-2.39,.03-4.66,0-6.88-.03-14.93-1.86-35.82,3.8-64.34-22.57h0s-41.07-56.34-87.07-32.74C.16,154.72,20.19,234.19,74.46,253.59,37.21,240.62,8.86,208.31,1.74,168.43,9.05,60.96,105.06,72.86,140.71,101.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.87,172.38c6.71,6.2,17.08,23.58,49.43,30.06-8.82,13.69-24.45,21.67-24.45,21.67-31.14-23.66-24.98-51.73-24.98-51.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.51,39.67c-11.71-2.28-24.75-2.88-38.29,0C106.29,23.09,95.83,0,95.83,0c0,0,31.33,8.21,33.68,39.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.17,178.39c-.29-20.01,8.11-38.61,27.43-48.52,45.93-23.57,86.95,32.57,87.06,32.73-2-1.94-3.95-3.92-5.94-5.89-3.96-3.94-8.87-6.83-14.28-8.66l-.06-.06s-33.25-29.41-65.22-12.33c-23.75,12.69-28.44,27.71-28.98,42.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239.72,189.4c.37,16.06-25.72,42.35-55.51,44.35-.69,.05-1.39,.09-2.08,.11l5.9-7.64s38.45-3.92,51.7-36.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M119.87,172.38c2.22,27.42,31.05,47.99,31.08,48.01-3.57,2.42-6.1,3.72-6.1,3.72-31.14-23.66-24.98-51.73-24.98-51.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M61.86,124.09c44.97-8.39,76.55,40.91,76.64,41.04-.93-.81-1.88-1.65-2.83-2.53h0s-41.07-56.34-87.07-32.74C.16,154.72,20.19,234.19,74.46,253.59c-9.53-3.32-18.47-7.92-26.63-13.58-14.85-13.38-20.91-27.99-25.53-41.77-6.65-19.85-4.47-65.93,39.55-74.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M138.56,165.19l7.11,5.63c-2.31-1.67-4.68-3.53-7.11-5.63Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M50.4,209.02c-26.28-53.65,27.79-90.61,68.97-59.44-5.67-2.62-12.11-3.94-18.77-3.78-23.09,.53-37.98,16.18-37.03,42.68,.09,2.62,.39,5.13,.86,7.53h-.12c6.79,32.73,35.78,57.34,70.53,57.34,10.19,0,19.88-2.13,28.67-5.95-.17,.1-.35,.19-.52,.29-7.33,3.72-78.47,31.01-112.6-38.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M163.68,247.31v.02c-.05,.02-.11,.04-.16,.06,.05-.03,.11-.06,.16-.09Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGigsLogo);
export default __webpack_public_path__ + "static/media/gigs-logo.492d4bf24b840a8ce1b3ceb75d1bcfee.svg";
export { ForwardRef as ReactComponent };